// src/App.js
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './lib/AuthContext';
import Landing    from './pages/Landing';
import Signup     from './pages/Signup';
import Login      from './pages/Login';
import Onboarding from './pages/Onboarding';
import Dashboard  from './pages/Dashboard';
import Settings   from './pages/Settings';
import Bookings   from './pages/Bookings';
import Performance from './pages/Performance';
import Knowledge  from './pages/Knowledge';

// Redirect logged-in users away from auth pages
function PublicRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><div className="spinner spinner-dark" /></div>;
  if (user) return <Navigate to="/dashboard" replace />;
  return children;
}

// Require login — redirect to onboarding if no business record yet
function PrivateRoute({ children }) {
  const { user, business, loading } = useAuth();
  if (loading) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><div className="spinner spinner-dark" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

// Require completed onboarding
function OnboardedRoute({ children }) {
  const { user, business, loading } = useAuth();
  if (loading) return <div style={{ minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}><div className="spinner spinner-dark" /></div>;
  if (!user) return <Navigate to="/login" replace />;
  if (!business) return <Navigate to="/onboarding" replace />;
  return children;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/"           element={<Landing />} />
      <Route path="/signup"     element={<PublicRoute><Signup /></PublicRoute>} />
      <Route path="/login"      element={<PublicRoute><Login /></PublicRoute>} />
      <Route path="/onboarding" element={<PrivateRoute><Onboarding /></PrivateRoute>} />
      <Route path="/dashboard"  element={<OnboardedRoute><Dashboard /></OnboardedRoute>} />
      <Route path="/settings"   element={<OnboardedRoute><Settings /></OnboardedRoute>} />
      <Route path="/bookings"   element={<OnboardedRoute><Bookings /></OnboardedRoute>} />
      <Route path="/performance" element={<OnboardedRoute><Performance /></OnboardedRoute>} />
      <Route path="/knowledge"  element={<OnboardedRoute><Knowledge /></OnboardedRoute>} />
      <Route path="*"           element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
